// extracted by mini-css-extract-plugin
module.exports = {"border":"contact_border__2TFEE","sectionNumber":"contact_sectionNumber__vyh2S","contact":"contact_contact__3xQyf","main":"contact_main__2-2_P"};